import { Injectable } from "@angular/core";
import { IID_OL_ESPLETATO_OK } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolEspletatoOkStore } from "./espletatoOk.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ESPLETAMENTO_POSITIVO)
export class IIDolEspletatoOkQuery extends AbstractInterfaceDataQuery<IID_OL_ESPLETATO_OK> {

  constructor(protected store: IIDolEspletatoOkStore) {
    super(store);
  }
}
